import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useBanksList() {
    const toast = useToast()
    const records = ref(null)

    // Table Handler
    const columns = [
        {
            key: 'logo', label: '', sortable: false, thStyle: { width: '5%' }, thClass: 'text-center', tdClass: 'text-center',
        },
        {
            key: 'name', label: 'Bank Name', sortable: true, thStyle: { width: '50%' }, thClass: 'text-left', tdClass: 'text-left',
        },
        {
            key: 'abbreviation', sortable: true, thStyle: { width: '25%' }, thClass: 'text-left', tdClass: 'text-left',
        },
        {
            key: 'branches', label: '# of Branches', thStyle: { width: '15%' }, thClass: 'text-right', tdClass: 'text-right',
        },
        'actions',
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('name')
    const isSortDirDesc = ref(true)

    const myBanks = ref([])

    const refetch = () => {
        records.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-bank/list', {
                query: searchQuery.value,
                per_page: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const { banks, meta } = response.data
                myBanks.value = banks

                meta.value = meta

                callback(banks)
                totalRecords.value = meta.value.total
                from.value = meta.value.from
                to.value = meta.value.to
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching banks list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resolveStatusVariant = status => {
        if (status) return 'success'
        if (!status) return 'secondary'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,
        myBanks,

        // resolveUserRoleVariant,
        // resolveUserRoleIcon,
        resolveStatusVariant,
        refetch,

        // Extra Filters
        // roleFilter,
        // planFilter,
        // statusFilter,
    }
}
